import map from 'lodash/map';
import keyBy from 'lodash/keyBy';
import sortBy from 'lodash/sortBy';

import * as actions from 'actions/plans';

const defaultState = {
  nav: [],
  updatedAllPlanForms: false,
};

// reduces `plans` subtree keyed by plan.id
export default function plans(state = defaultState, action) {
  const { type, payload } = action;

  switch (type) {
    case actions.GET_START:
      return {
        ...state,
        [payload.id]: {
          ...state[payload.id],
          status: 'LOADING',
        },
      };
    case actions.GET_SUCCESS:
    case actions.POST_SUCCESS:
      return {
        ...state,
        [payload.id]: {
          ...payload,
          status: 'LOADED',
        },
      };
    // cannot handle fail until httpServiceMiddleware returns action payload
    // case actions.GET_FAIL:
    //   return {
    //     ...state,
    //     [payload.id]: {
    //       status: 'FAILED',
    //     },
    //   };
    case actions.POST_START:
      return {
        ...state,
        [payload.id]: {
          ...state[payload.id],
          ...payload,
        },
      };
    case actions.GET_NAV_PLANS_START:
    case actions.GET_NAV_FORMS_BY_PLAN_START:
      return {
        ...state,
        navStatus: 'LOADING',
      };
    case actions.GET_NAV_PLANS_SUCCESS: {
      return {
        ...state,
        nav: sortBy(payload.data, 'position'),
        navStatus: 'LOADED',
      };
    }
    case actions.UPDATE_NAV_PLANS_AND_FORMS: {
      const detailedForms = map(payload, 'payload');
      const formsByPlanId = keyBy(detailedForms, 'planId');
      const nav = state.nav.map(plan => {
        const formsFound = formsByPlanId[plan.id];
        return formsFound ? { ...plan, forms: formsFound } : plan;
      });
      return {
        ...state,
        nav,
        updatedAllPlanForms: true,
        navStatus: 'LOADED',
      };
    }

    // cannot handle fail until httpServiceMiddleware returns action payload
    // case actions.POST_FAIL:
    //   return {
    //     ...state,
    //     [payload.id]: {
    //       ...payload[payload.id],
    //       ...payload,
    //     },
    //   };

    default:
      return state;
  }
}
